export enum ADB2CUserGroup {
  Administrators = 'Administrators',
  CompanyAdmin = 'Company Administrator',
  Everyone = 'Everyone',
  ExComm = 'ExComm',
  GsCompanyRepresentative = 'GS Company Representative',
  LearnReaders = 'LearnReaders',
  MDRTStaff = 'MDRT Staff',
  WebAdmins = 'WebAdmins',
  WebEditors = 'WebEditors',
}

export enum AuthProviderName {
  BiometricDeregister = 'b2c-biometric-deregister',
  BiometricRegistration = 'b2c-biometric-registration',
  CreateAccount = 'b2c-create-account',
  PasswordReset = 'b2c-password-reset',
  RemoveSocialSignIn = 'b2c-remove-social-sign-in',
  SignIn = 'azure-ad-b2c',
  SocialSignIn = 'b2c-social-sign-in',
}
